import { render, staticRenderFns } from "./SmallMountedPrints.vue?vue&type=template&id=1e73eb68"
import script from "./SmallMountedPrints.vue?vue&type=script&lang=js"
export * from "./SmallMountedPrints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports